<script>
/**
 * @file 教师端-个人中心
 */
import Confirm from '../confirm';

export default {
    components: {
        Confirm
    },
    methods: {
        goback() {
            this.$router.push({
                name: 'teacher-home'
            });
        },
        handleOk() {
            this.isShowLogout = false;
        },
        handleCancel() {
            this.isShowLogout = false;
        }
    },
    data() {
        return {
            isShowLogout: false,
            isShowSelectBox: false,
            status: 'mother-to-be'
        };
    }
};
</script>

<template lang="pug">
.forkiss-my-userinfo-container
    .my-userinfo-container
        .my-userinfo-header 我的信息
            .back-btn(@click="goback", data-touch="true")
        .info-box.img-box
            label 头像
            span.img
        .info-box
            label 姓名
            span 李建慧
        .info-box
            label 手机号
            span 18635000976
        button.my-userinfo-footer(@click="isShowLogout = true", data-touch="true") 退出登录
    Confirm(:show="isShowLogout", message="确定退出登录？", @ok="handleOk",
        @close="handleCancel")

</template>
<style lang="less" scoped>
.forkiss-my-userinfo-container {
    position: relative;
    font-size: .24rem;
    background: #FFF;
    padding-bottom: 1.16rem;
    color: #333;

    .my-userinfo-header {
        position: relative;
        height: .9rem;
        line-height: .9rem;
        font-size: .36rem;
        text-align: center;
        box-shadow: 0 .05rem .08rem 0 rgba(227, 227, 227, .27);
    }
    .back-btn {
        position: absolute;
        z-index: 22;
        top: 50%;
        left: .2rem;
        transform: translateY(-50%);
        width: .2rem;
        height: .36rem;
        background-image: url(../../assets/back-black.png);
        background-size: contain;
        background-repeat: no-repeat;
    }

    .info-box {
        position: relative;
        height: 1.24rem;
        line-height: 1.24rem;
        padding: 0 .3rem;

        &.img-box {
            height: 1.3rem;
            line-height: 1.3rem;
        }
        &::after {
            content: "";
            position: absolute;
            right: .3rem;
            left: .3rem;
            bottom: 0;
            height: 1px;
            background: #EEE;

        }
        label {
            font-size: .32rem;
        }

        span {
            float: right;
            font-size: .28rem;
            color: #999999;

            &.right-arrow {

                &::after {
                    content: "";
                    display: inline-block;
                    vertical-align: middle;
                    width: .16rem;
                    height: .28rem;
                    margin-left: .15rem;
                    background-image: url(../../assets/center-arrow.png);
                    background-repeat: no-repeat;
                    background-size: contain;
                }

            }

            &.img {
                display: inline-block;
                margin: .21rem 0;
                width: .88rem;
                height: .88rem;
                border-radius: 50%;
                background-image: url(../../assets/classes-avatar1.png);
                background-size: contain;
                background-repeat: no-repeat;
                border: 0.02rem solid #edd3b7;
            }
        }
    }

    .my-userinfo-footer {
        position: fixed;
        z-index: 1;
        width: 5.9rem;
        height: .96rem;
        left: 50%;
        bottom: .86rem;
        transform: translateX(-50%);
        margin: 0 auto;
        border: none;
        border-radius: .5rem;
        line-height: .96rem;
        color: #FFF;
        background: #c3a07b;
        font-size: .36rem;
        outline: none;
    }

    .status-select-box {
        position: relative;

        .select-box-mask {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 2;
            background: rgba(0, 0, 0, .6);
        }

        .select-container {
            position: fixed;
            right: 0;
            bottom: 0;
            left: 0;
            height: 2.56rem;
            z-index: 3;
        }

        .select-wrapper {
            position: absolute;
            width: 100%;
            bottom: 0;
            list-style: none;
            margin: 0;
            padding: 0;

            li {
                display: block;
                height: 1.28rem;
                line-height: 1.28rem;
                background: #FFF;
                font-size: .28rem;
                color: #666;
                text-align: center;

                &.active {
                    background: #EEE;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/teacher/center.vue